import React, { useEffect } from 'react'
import { withFormik, Form, Field } from 'formik'
import { Link } from 'react-router-dom'
import { resetPassword } from '../utils/authService';
import { withTranslation } from 'react-i18next';

const validate = (values, props) => {
  let errors = {};

  if (!values.userName) {
    errors.userName = props.t('enterUserName');
  }


  return errors;
};

const ForgotPasswordComponent = (props) => {
  const {
    values,
    handleChange,
    dirty,
    errors,
    t,
    touched,
    isSubmitting
  } = props

  useEffect(() => {
    document.title = `City of Seattle | Forgot Password`
  }, [])
    
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    values.appName = getParameterByName('appName') ? getParameterByName('appName') : "";
    var link = '/login?appName=' + values.appName;


  return (
    <div>
      <h2>{t("forgotPassword")}</h2>
      <p>{t('enterForInstructions')}</p>
      <Form className="App-form">

        <div className={"form-group form-group-lg " + (errors.userName && touched.userName ? 'has-error' : '')}>
          <label htmlFor="userName" className="control-label">{t('userName')} <span className="text-danger">*</span></label>
          <Field type="userName" className="form-control" name="userName" value={values.userName} onChange={handleChange} />
          {errors.userName && touched.userName && <div className="text-danger exception-margin" role="alert">
            <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span className="sr-only">Error:</span>
            {touched.userName && errors.userName}
          </div>}
        </div>


          <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={!dirty || isSubmitting}>{t('submit')}</button>
      </Form>
      <div className="return-link">
              <Link to={ link }>{t('returnLogin')}</Link>
      </div>

    </div>

  )
}

const ForgotPassword = withFormik({
  mapPropsToValues({ userName }) {
    return {
      userName: userName || ''
    }
  },
  validate: validate,
    handleSubmit(values, { props, setSubmitting }) {
        var appName = values.appName;
        var userName = values.userName;
    resetPassword(userName, appName).then(response => {
      props.setSendPasswordEmail(userName);
    }).catch(error => {
      props.showNotification({
        type: 'failure',
        title: props.t('forgotPasswordFailedTitle'),
        message: props.t('forgotPasswordFailed')
      }
      );
    })
    .finally(() => {
      setSubmitting(false);
    });
  }
})(ForgotPasswordComponent)

export default withTranslation()(ForgotPassword);
